import { useRequest } from "../../../app/hooks/useRequest";
import {
  createProviderProgramRequest,
  updateProgramRequest,
} from "../ProgramRequests";

export const useCreateProgram = () => useRequest(createProviderProgramRequest);
export const useUpdateProgram = () => useRequest(updateProgramRequest);
